import _slicedToArray from "/home/runner/work/website/website/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useMemo as o, useReducer as c } from "react";
import { useIsoMorphicEffect as h } from './use-iso-morphic-effect.js';
function s(e) {
  if (e === null) return {
    width: 0,
    height: 0
  };
  var _e$getBoundingClientR = e.getBoundingClientRect(),
    n = _e$getBoundingClientR.width,
    t = _e$getBoundingClientR.height;
  return {
    width: n,
    height: t
  };
}
function f(e) {
  var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
  var t = e === null ? null : "current" in e ? e.current : e,
    _c = c(function () {
      return {};
    }, {}),
    _c2 = _slicedToArray(_c, 2),
    l = _c2[0],
    u = _c2[1],
    r = o(function () {
      return s(t);
    }, [t, l]);
  return h(function () {
    if (!t) return;
    var i = new ResizeObserver(u);
    return i.observe(t), function () {
      i.disconnect();
    };
  }, [t]), n ? {
    width: "".concat(r.width, "px"),
    height: "".concat(r.height, "px")
  } : r;
}
export { f as useElementSize };